<template>
  <el-dialog
    class="radish-dia"
    :title="`${name}的建议业绩`"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="dialogVisible = false"
  >
    <div v-if="yeji.length > 0" class="radish-dia-body" style="padding-bottom: 15px;">
      <el-table :data="yeji" size="mini" :resizable="false">
        <el-table-column label="建议业绩" prop="建议业绩" width="100px"></el-table-column>
        <el-table-column label="来源" prop="来源" width="100px"></el-table-column>
        <el-table-column label="理由" prop="理由"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      name: '',
      yeji: [],
    }
  },
  methods: {
    show: function(name, yeji) {
      this.name = name
      this.yeji = yeji
      this.dialogVisible = true
    },
  },
}
</script>
